export const ISSUE_AREA_OPTIONS = [
    { label: 'Survey Pulse', key: 'survey-pulse' },
    { label: 'My Surveys', key: 'my-surveys' },
    { label: 'Crosstabs', key: 'crosstabs' },
    { label: 'Survey Builder', key: 'survey-builder' },
    { label: 'Current Market Trends', key: 'current-market-trends' },
    { label: 'Brand Image', key: 'brand-image' },
    { label: 'General Questions', key: 'general-questions' },
    { label: 'Survey Portal', key: 'survey-portal' },
];
